import type { LevelConfig } from '../index';

export const level9: LevelConfig = {
  id: 'level_9',
  stage: '2',
  mapId: 'map_09',
  timeLimitSec: 160,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 3 },
  secondaryObjective: { type: 'find_key', target: 1 },
  enemies: [
    { type: 'INVESTOR_SCAMMER', position: { x: 400, y: 350 }, patrolPath: [{ x: 400, y: 350 }, { x: 400, y: 550 }, { x: 250, y: 550 }] },
    { type: 'INVESTOR_SCAMMER', position: { x: 700, y: 500 }, patrolPath: [{ x: 700, y: 500 }, { x: 700, y: 700 }, { x: 550, y: 700 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 550, y: 300 }, patrolPath: [{ x: 550, y: 300 }, { x: 550, y: 500 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 350, y: 750 }, patrolPath: [{ x: 350, y: 750 }, { x: 550, y: 750 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 800, y: 350 }, patrolPath: [{ x: 800, y: 350 }, { x: 800, y: 550 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 250, y: 600 }, patrolPath: [{ x: 250, y: 600 }, { x: 250, y: 800 }] },
  ],
  loot: [
    ...Array.from({ length: 25 }, (_, i) => ({
      type: 'COIN' as const,
      position: { x: 180 + (i % 5) * 150, y: 220 + Math.floor(i / 5) * 150 },
      value: 10,
    })),
    { type: 'QUEST_ITEM', position: { x: 850, y: 200 }, value: 1 },
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 5,
  unlocks: [],
};
